// extracted by mini-css-extract-plugin
export default {"illustrationCard":"IllustrationCard_illustrationCard__f7l8A"};